import Vue from 'vue'


//  selectInput
Vue.directive('selectInput', {
  bind(element, binding, vnode) {
    const input = element.querySelector('input');
    let action = () => {
      try {
        if (binding.expression) {
          let keys = binding.expression.split("\.");
          let model = vnode.context;
          let key = keys[0];

          if (key == "commodityList") {
            model = model.commodityList[model.currIndex];
          } else {
            for (let i = 1; i < keys.length; i++) {
              key = keys[i - 1];
              let nextKey = keys[i];
              if (model && key && model[key] && model[key].hasOwnProperty(nextKey)) {
                model = model[key];
                key = nextKey;
              } else {
                return;
              }
            }
          }
          key = keys[keys.length - 1];
          model[key] = input.value;
          // element.handleClose();
          // vnode.context.$refs.carrerSelect.handleClose();
          // console.log(model);
          // console.log(key);
        }

      } catch (e) {
        console.log(e);
      }
    };
    input.addEventListener('blur', action);
    input.addEventListener("keydown",(event)=>{
      if(event.key == 'Enter'){
        let selectDom = document.getElementsByClassName("el-select-dropdown el-popper");
        if(selectDom){
          Object.keys(selectDom).forEach(k=>{
            if(selectDom[k].style.display != 'none'){
              selectDom[k].style.display = 'none';
              event.stopPropagation();
            }
          })
        }
        // input.blur();
      }
    });
  },
})

// v-dialogDrag: 弹窗拖拽
Vue.directive('dialogDrag', {
	bind(el, binding, vnode, oldVnode) {
		const dialogHeaderEl = el.querySelector('.el-dialog__header');
		const dragDom = el.querySelector('.el-dialog');
		dialogHeaderEl.style.cursor = 'move';

		// 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
		const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

		dialogHeaderEl.onmousedown = (e) => {
			// 鼠标按下，计算当前元素距离可视区的距离
			const disX = e.clientX - dialogHeaderEl.offsetLeft;
			const disY = e.clientY - dialogHeaderEl.offsetTop;

			const screenWidth = document.body.clientWidth;// body当前宽度
			const screenHeight = document.documentElement.clientHeight;// 可见区域高度(应为body高度，可某些环境下无法获取)

			const dragDomWidth = dragDom.offsetWidth;// 对话框宽度
			const dragDomheight = dragDom.offsetHeight;// 对话框高度

			const minDragDomLeft = dragDom.offsetLeft;
			const maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth;

			const minDragDomTop = dragDom.offsetTop;
			const maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomheight;

			// 获取到的值带px 正则匹配替换
			let styL, styT;

			// 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
			if (sty.left.includes('%')) {
				styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
				styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
			} else {
				styL = +sty.left.replace(/\px/g, '');
				styT = +sty.top.replace(/\px/g, '');
			}

			let navW = document.documentElement.getElementsByClassName('home_nav')[0].scrollWidth + 5;// 获取侧边导航的宽度
			let headH = document.documentElement.getElementsByClassName('home_header')[0].scrollHeight;// 页面头部的高
			document.onmousemove = function (e) {
				// 获取body的页面可视宽高
				// var clientHeight = document.documentElement.clientHeight || document.body.clientHeight
				// var clientWidth = document.documentElement.clientWidth || document.body.clientWidth

				// 通过事件委托，计算移动的距离
				let l = e.clientX - disX;
				let t = e.clientY - disY;

				// 边界处理
				if (-l > minDragDomLeft) {
					l = -minDragDomLeft;
				} else if (l + navW > maxDragDomLeft) {
					l = maxDragDomLeft - navW;
				}
				if (-t > minDragDomTop) {
					t = -minDragDomTop;
				} else if (t + headH > maxDragDomTop) {
					t = maxDragDomTop - headH;
				}

				// 移动当前元素
				dragDom.style.left = `${l + styL}px`;
				dragDom.style.top = `${t + styT}px`;

				// 将此时的位置传出去
				// binding.value({x:e.pageX,y:e.pageY})
			}

			document.onmouseup = function (e) {
				document.onmousemove = null;
				document.onmouseup = null;
			}
		}
	}
})

// v-dialogDragWidth: 弹窗宽度拖大 拖小
Vue.directive('dialogDragWidth', {
	bind(el, binding, vnode, oldVnode) {
		const dragDom = binding.value.$el.querySelector('.el-dialog');
		el.onmousedown = (e) => {
			// 鼠标按下，计算当前元素距离可视区的距离
			const disX = e.clientX - el.offsetLeft;
			const disY = e.clientY - el.offsetTop;

			let clientWidth = dragDom.clientWidth;
			let offsetHeight = dragDom.offsetHeight;

			document.onmousemove = function (e) {
				e.preventDefault();// 移动时禁用默认事件

				// 通过事件委托，计算移动的距离
				const w = e.clientX - disX;
				const h = e.clientY - disY;

				dragDom.style.width = `${w + clientWidth}px`;
				dragDom.style.height = `${h + offsetHeight}px`;
			}

			document.onmouseup = function(e) {
				document.onmousemove = null;
				document.onmouseup = null;
			}
		}
	}
})



// WEBPACK FOOTER //
// ./src/assets/directives.js